<template>
    <nav class="mh-bottom-nav" :aria-label="pcCopy.casino">
        <button v-for="item in items" :key="item.id" type="button" :class="{ selected: active === item.id }" :aria-current="active === item.id ? 'page' : null" @click="$emit('select', item.id)"><img v-theme-art="controlIcon(item.icon + (active === item.id ? '-active' : ''))" :src="controlIcon(item.icon + (active === item.id ? '-active' : ''))" alt="" /><span>{{ item.label }}</span></button>
    </nav>
</template>

<script>
import desktopCopy from '@/components/desktop/copy'
import mobileCopy from './copy'
import { controlIcon } from './assets'
export default {
    mixins: [desktopCopy, mobileCopy],
    props: { active: { type: Number, default: 1 } },
    computed: { items() { return [{ id: 2, icon: 'menu', label: this.$t('tabbar.menu') }, { id: 1, icon: 'casino', label: this.pcCopy.casino }, { id: 3, icon: 'affiliate', label: this.pcCopy.affiliate }, { id: 4, icon: 'vip', label: 'VIP' }, { id: 5, icon: 'account', label: this.mobileHomeCopy.account }] } },
    methods: { controlIcon }
}
</script>

<style scoped lang="scss">
.mh-bottom-nav { position: fixed; left: 0; right: 0; bottom: 0; z-index: 100; display: flex; padding: 6px 8px max(7px, env(safe-area-inset-bottom)); background: #181b20; border-top: 1px solid #34343a; font-family: Inter, "Segoe UI", Arial, sans-serif; }
.mh-bottom-nav button { position: relative; flex: 1 1 0; min-width: 0; min-height: 51px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 3px; border: 0; padding: 0 0 4px; background: none; color: #c9c7ce; font: inherit; font-size: 13px; cursor: pointer; }
.mh-bottom-nav img { width: 26px; height: 26px; }
.mh-bottom-nav .selected { color: #ff6055; }
.mh-bottom-nav .selected::after { content: ''; position: absolute; bottom: 0; height: 2px; width: 32px; border-radius: 2px; background: #ff6055; }
.mh-bottom-nav button:focus-visible { outline: 2px solid #ff6055; outline-offset: -2px; border-radius: 8px; }
</style>
